<template>
  <vs-row>
    <vs-row v-for="(product, index) in defaultProducts" :key="`product_${index}`">
      <DefaultProductRow :product="product" />
    </vs-row>
  </vs-row>
</template>

<script>
import { defineComponent, PropType } from '@vue/composition-api'
import DefaultProductsStore from '@/store/socialStream/socialStreamDefaultProducts'
import DefaultProductRow from '@/views/components/socialStream/DefaultProductRow.vue'

export default defineComponent({
  name: 'DefaultProductsList',
  components: {
    DefaultProductRow,
  },
  props: {
  },
  data() {
    return {
      columnNames: [
        'catalogImport.catalogProductsList.id',
        'catalogImport.catalogProductsList.title',
        'catalogImport.catalogProductsList.image',
        'catalogImport.catalogProductsList.actions',
      ],
      opened: '',
    }
  },
  computed: {
    defaultProducts() {
      if(DefaultProductsStore.state.linkedProducts !== null){
        return  Object.values(DefaultProductsStore.state.linkedProducts)
      }else{
        return []
      }
    },
  },
  watch: {
  },
  methods: {
  },
})
</script>

<style scoped>

</style>


